import styled from 'styled-components';
export const CustomAmpersand = styled.span`
  font-family: Palatino, Baskerville;
  font-style: italic;
`;